import Api from '../util/Api';

const Discounts = {
    /**
     * @param coupon
     * @return {*}
     */
    set(coupon) {
        return Api.post('/api/discounts/coupon/add/', {
            coupon
        });
    },

    delete(coupon) {
        return Api.post('/api/discounts/coupon/delete/', {
            coupon
        });
    }
};
export default Discounts;
